import React from 'react';
import { Route } from 'react-router-dom';
import { Header } from '../partials';
import '../Layout.css';

export default function PublicLayout({ component: Component, ...rest }) {
  return (
    <Route {...rest} render={props => (
      <div className="app">
        <Header/>
        <div className="container">
          <Component {...props} />
        </div>
      </div>
    )}/>
  );
};



// WEBPACK FOOTER //
// ./src/layouts/public-layout/PublicLayout.jsx